import { React, PropTypes, reduxConnect, css, styled } from '../lib/imports';

import { Grid, Col, Image, Spacing, SectionTitle, Text, Divider } from '../components';
import GameItem from '../games/GameItem';
import { getFormattedTimestamp } from '../lib/date';

const containerBaseStyles = () => css`
  display: flex;
  flex-direction: column;

  p {
    margin: 0;
  }
`;

const Container = styled('div')(containerBaseStyles);

const imageWrapperBaseStyles = ({ theme }) => css`
  max-width: 25px;
  margin-right: ${theme.spacings.byte};
`;

const ImageWrapper = styled('div')(imageWrapperBaseStyles);

const GameBuilder = ({ title, gameList, lastGameItemIndex }) => (
  <Container>
    <Spacing>
      <SectionTitle text={title} />
    </Spacing>
    <Spacing sizeTop='byte' sizeBottom='byte' sizeLeft='kilo' sizeRight='kilo'>
      {gameList.map(({ gameTime, gameStarted, homeTeam, awayTeam }, index) => (
        <GameItem key={index} inactive={gameStarted}>
          <Spacing sizeTop='bit' sizeBottom='bit'>
            <Grid>
              <Col columns='2'>
                <Text size='bit' bold>
                  {gameTime}
                </Text>
              </Col>
              <Col columns='1'>
                <ImageWrapper>
                  <Image src={awayTeam.teamLogo} alt={awayTeam.teamName} />
                </ImageWrapper>
              </Col>
              <Col columns='3'>
                <Text>{awayTeam.teamName}</Text>
              </Col>

              <Col columns='1'>
                <Text size='kilo'>@</Text>
              </Col>
              <Col columns='1'>
                <ImageWrapper>
                  <Image src={homeTeam.teamLogo} alt={homeTeam.teamName} />
                </ImageWrapper>
              </Col>
              <Col columns='3'>
                <Text>{homeTeam.teamName}</Text>
              </Col>
            </Grid>
          </Spacing>
          {lastGameItemIndex !== index && <Divider />}
        </GameItem>
      ))}
    </Spacing>
  </Container>
);

GameBuilder.propTypes = {
  title: PropTypes.string,
  lastGameItemIndex: PropTypes.number,
  gameList: PropTypes.array,
};

const mapStateToProps = (state) => {
  const { config, strings, games } = state;
  const { language } = config;

  const allStrings = {
    title: strings['titles/section/games/text'],
  };

  const getTeamDetails = (team) => ({
    teamName: team?.name || 'team 1',
    teamCity: team?.city || 'city 1',
    teamLogo: team?.logo || '',
  });

  const gameList = games.all.map(({ startTime, started, teams, venue }) => {
    const gameTime = getFormattedTimestamp(startTime, language);
    const gameStarted = started;

    const homeTeam = getTeamDetails(teams.home);
    const awayTeam = getTeamDetails(teams.away);

    return {
      gameTime: gameStarted ? strings['global/games/status/started/text'] : gameTime,
      gameStarted,
      homeTeam,
      awayTeam,
      venue,
    };
  });

  return {
    ...allStrings,
    gameList,
    lastGameItemIndex: gameList.length - 1,
  };
};

export default reduxConnect(mapStateToProps)(GameBuilder);
